import IconAsMaskImage from "../IconAsMaskImage";

const CheckIcon = ({ pureSvg, className, color }) => {
  const svg = (
    <>
      <svg
        width="9"
        height="8"
        viewBox="0 0 9 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4.0997L3.25017 6.5L8 1.5"
          stroke="#7C0069"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;

};

export default CheckIcon;
